import type { ConsiderationColor } from '~kui/utils/considerationColor';

import type { ConsiderationAreaColor } from '~/graphql/generated/graphql';

/**
 * The GraphQL `ConsiderationAreaColor` enum exposes UPPERCASE case names (e.g. `LIME`), while the
 * KUI palette type `ConsiderationColor` uses the lowercase design tokens (`lime`, the brand lime).
 * They are the same set, so map by case between the wire value and the render value.
 */
export const toConsiderationColor = (color: ConsiderationAreaColor): ConsiderationColor =>
  color.toLowerCase() as ConsiderationColor;

export const toGraphqlConsiderationColor = (color: ConsiderationColor): ConsiderationAreaColor =>
  color.toUpperCase() as ConsiderationAreaColor;
